import * as types from "../types";

const initialState = {
  // EVENTS
  events: null,
  listLoading: false,
  errorList: null,
};

export const events = (state = initialState, action) => {
  switch (action.type) {
    // GET EVENTS
    case types.GET_EVENTS_REQUEST:
      return {
        ...state,
        listLoading: true,
        errorList: null,
      };
    case types.GET_EVENTS_SUCCESS:
      return {
        ...state,
        listLoading: false,
        events: action.payload,
      };
    case types.GET_EVENTS_FAIL:
      return {
        ...state,
        listLoading: false,
        errorList: action.payload,
      };
    default:
      return state;
  }
};
